import classNames from 'classnames';
import React from 'react';
export const PeriscopeTablessContent = ({ children, className = '' }) => React.createElement("div", { className: classNames('periscope-content-tabless', className) }, children);
